/**
 * Paths guests may browse without signing in.
 * Used by the API 401 handler and SoftGateAuthRedirect.
 */
export function isGuestBrowsePath(pathname: string): boolean {
  if (pathname === "/" || pathname === "") {
    return true;
  }
  if (pathname === "/search" || pathname.startsWith("/search?")) {
    return true;
  }
  if (pathname.startsWith("/vendor/")) {
    return true;
  }
  if (pathname.startsWith("/items/share/")) {
    return true;
  }
  if (/^\/items\/[^/]+\/?$/.test(pathname)) {
    return true;
  }
  if (
    pathname === "/about-us" ||
    pathname === "/privacy-policy" ||
    pathname === "/terms-and-conditions"
  ) {
    return true;
  }
  return false;
}
